module.exports = __webpack_public_path__ + "img/law3m-m@1.473a8b46.webp";